module.exports = __webpack_public_path__ + "static/media/bytt-no-13.bfe7d18e.mp3";